module.exports = __webpack_public_path__ + "static/media/slide-3.a3413bac.jpg";